export const UPDATE_LAST_ACCESSED_COURSE = 'UPDATE_LAST_ACCESSED_COURSE';
